module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/device-type/device-type.component.css
// module id = ./src/app/device-type/device-type.component.css
// module chunks = main